import styled, {css, useTheme} from "styled-components";
import HomepageCard, {typologies} from "./HomepageCard";
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";
import __ from "../../utils/translator";
import ShowAllCarouselButton from "../molecules/ShowAllCarouselButton";

import { Swiper, SwiperSlide } from 'swiper/react';

const showAllUrls = {
  seasonal: '/seasonal',
  timeless: '/timeless',
  'merchandising-manual': '/manuals',
  'product-focus': '/product-focuses'
}

export default function HomepageCarousel({
  elements,
  fullscreen = false,
  enableShowAllButton = false
}) {
  const appTheme = useTheme();
  const hasGlossary = elements.some(element => element.typology === typologies.glossary);
  const mobileVisibleSlides= 'auto';
  const tabletVisibleSlides = hasGlossary ? 2 : 'auto';
  const mobileSlidesGap = fullscreen ? 0 : 12;
  const tabletSlidesGap = 20;

  return (
    <div>
      <StyledSwiper
        $fullscreen={fullscreen}
        $enableShowAllButton={enableShowAllButton}
        slidesPerView={appTheme.isMobile ? mobileVisibleSlides : tabletVisibleSlides}
        pagination={elements.length > 1 ? {clickable: true}: false}
        spaceBetween={appTheme.isMobile ? mobileSlidesGap : tabletSlidesGap}
        freeMode={appTheme.isTablet ? {
          sticky: true,
        } : undefined}
      >
        {elements.map((element, index) => (
          <SwiperSlide
            key={index}
            style={{width: appTheme.isTablet && fullscreen ? 'auto' : undefined}}
          >
            <HomepageCard
              fullscreen={fullscreen}
              {...element}
            />
          </SwiperSlide>
        ))}
        {enableShowAllButton && (
          <SwiperSlide
            style={{
              width: '11.5rem'
            }}
          >
            <ShowAllCarouselButton
              to={showAllUrls[elements[0].typology] || '/'}
              text={__(`Show all ${elements[0].typology}`)}
            />
          </SwiperSlide>
        )}
      </StyledSwiper>
    </div>
  )
}

const StyledSwiper = styled(Swiper)`
  width: 100%;
  position: relative;

  ${props => props.$fullscreen ? css`
    padding: ${themeResponsiveProperty("0", "0 3rem")};`: css`
    padding: ${themeResponsiveProperty("0 1rem", "0 5rem 0 3rem")};`
  }
  padding-bottom: ${themeResponsiveProperty("2rem", "3rem")};

  .swiper-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .swiper-pagination {
    bottom: ${themeResponsiveProperty("1rem", "2rem")};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: .5rem;
  }

  >.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 .125rem;
  }

  .swiper-pagination-bullet {
    background-color: #8B8B8B;
    opacity: .7;
    margin: 0;
    height: .1875rem;
    width: .1875rem;
  }

  ${props => props.$enableShowAllButton && (
    css`
      .swiper-pagination-bullet:last-child {
        display: none;
      }
    `
  )}

  .swiper-pagination-bullet-active {
    background-color: #000;
    opacity: 1;
    height: .5rem;
    width: .5rem;
  }

  .swiper-pagination-bullet:has(+ .swiper-pagination-bullet-active) {
    height: .375rem;
    width: .375rem;
  }

  .swiper-pagination-bullet-active + .swiper-pagination-bullet {
    height: .375rem;
    width: .375rem;
  }

  .swiper-pagination-bullet-active + .swiper-pagination-bullet + .swiper-pagination-bullet {
    height: .28844rem;
    width: .28844rem;
  }
`;
